module.exports = __webpack_public_path__ + "img/scene_18.2c2fc36e.jpg";